import React from 'react';

const RetentionMetricsCards = ({ data, isLoading, dataMode = 'users' }) => {
  const styles = {
    primaryBg: "#ffffff",
    secondaryBg: "#DDE2EE", 
    textPrimary: "#0f172a",
    textSecondary: "#666666",
    accentColor: "#1d0c46",
    borderColor: "#DDE2EE"
  };

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num?.toString() || '0';
  };

  const isWalletsMode = dataMode === 'wallets';

  const cards = isWalletsMode ? [
    {
      title: 'DAW',
      subtitle: 'Daily Active Wallets',
      value: data?.daw || 0
    },
    {
      title: 'WAW', 
      subtitle: 'Weekly Active Wallets',
      value: data?.waw || 0
    },
    {
      title: 'MAW',
      subtitle: 'Monthly Active Wallets', 
      value: data?.maw || 0
    }
  ] : [
    {
      title: 'DAU',
      subtitle: 'Daily Active Users',
      value: data?.dau || 0
    },
    {
      title: 'WAU', 
      subtitle: 'Weekly Active Users',
      value: data?.wau || 0
    },
    {
      title: 'MAU',
      subtitle: 'Monthly Active Users', 
      value: data?.mau || 0
    }
  ];

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {[1, 2, 3].map((i) => (
          <div key={i} className="p-4 md:p-6 animate-pulse" style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}>
            <div className="flex flex-col items-center justify-center text-center">
              <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
              <div className="h-6 bg-gray-200 rounded w-16"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      {cards.map((card, index) => (
        <div key={index} className="p-4 md:p-6" style={{ backgroundColor: styles.primaryBg, border: `1px solid ${styles.borderColor}` }}>
          <div className="flex flex-col items-center justify-center text-center">
            <p className="text-lg font-bold mb-1" style={{ color: styles.textPrimary, fontFamily: 'Raleway, sans-serif' }}>
              {formatNumber(card.value)}
            </p>
            <p className="text-xs font-medium" style={{ color: styles.textSecondary, fontFamily: 'Raleway, sans-serif' }}>
              {card.subtitle}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RetentionMetricsCards;
